import { Box, TextField, Typography } from "@mui/material";

import { TOOLBAR_COLORS } from "components/toolbars/constants";
import { SidePanelProps } from "contexts/sidePanels";

interface MockPanelProps extends SidePanelProps {
    title: string;
}

/**
 * A placeholder panel for features not yet implemented
 */
export function MockPanel({ title }: MockPanelProps) {
    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            {/* Search bar matching the mockup */}
            <Box sx={{ p: 2 }}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    variant="outlined"
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            backgroundColor: TOOLBAR_COLORS.PANEL_BG,
                            borderRadius: "8px",
                        },
                    }}
                />
            </Box>

            {/* Empty state */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                }}
            >
                <Typography variant="body2">{title} content coming soon</Typography>
            </Box>
        </Box>
    );
}

// Individual mock panels
export function ViewsMarkupsPanel(props: SidePanelProps) {
    return <MockPanel {...props} title="Views & Markups" />;
}

export function AllItemsPanel(props: SidePanelProps) {
    return <MockPanel {...props} title="All Items" />;
}

export function GroupsPanel(props: SidePanelProps) {
    return <MockPanel {...props} title="Groups" />;
}

export function DeviationsPanel(props: SidePanelProps) {
    return <MockPanel {...props} title="Deviations" />;
}
